import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/sobre-qbd/qbd-group-foundation")({
  head: () => buildRouteHead("/es/sobre-qbd/qbd-group-foundation", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/sobre-qbd/fundacion", replace: true });
  },
});
